module.exports = __webpack_public_path__ + "img/icon_leader.9b29a166.svg";